import { map } from 'rxjs/internal/operators/map';
import { TranslateService } from '@ngx-translate/core';
import { Injectable } from '@angular/core';
import { StringConstants } from '../_constants/stringConstants';
import { StorageService } from './storage.service';
import { HttpClient } from '@angular/common/http';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
import { Platform } from '@ionic/angular';
import { APPCONFIG, Config } from '../_store';
import { Device } from '@ionic-native/device/ngx';
import * as CryptoJS from 'crypto-js';
import { ObjectTransformService } from './object-transform.service';

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  private _imei;
  private _deviceId;

  private currentPlatformType;

  //private httpClient: HttpClient;

  constructor(
    private strorageService: StorageService,
    //httpBackend: HttpBackend,
    private iab: InAppBrowser,
    private httpClient: HttpClient,
    private device: Device,
    private transformService: ObjectTransformService,
    private translateService: TranslateService,
    private platform: Platform) {
    //this.httpClient = new HttpClient(httpBackend);
    this.init();
  }

  init() {
    this.IMEI();
    this.DEVICEID();
    const platform = this.getCurrentPlatform();
    //platform type is param to be sent in each request call
    //1 for android, 2 for web and 3 for ios
    this.currentPlatformType = this.platform.is('cordova') ? (this.platform.is('ios') ? 3 : 1) : 2;
  }

  imei() {
    return this._imei;
  }

  deviceId() {
    return this._deviceId;
  }

  private IMEI() {
    const sessionStr = StringConstants.IMEI_sessionStr;
    let imei = this.strorageService.getLocalStorage(sessionStr);
    if (!imei) {
      imei = this.generateRandomString(15);
      this.strorageService.addLocalStorage(sessionStr, imei);
    } else {
      this._imei = imei;
    }
    return imei;
  }

  private DEVICEID() {
    const sessionStr = StringConstants.DEVICEID_sessionStr;
    let deviceId = this.strorageService.getLocalStorage(sessionStr);
    if (!deviceId) {
      deviceId = this.generateRandomString(15);
      this.strorageService.addLocalStorage(sessionStr, deviceId);
    } else {
      this._deviceId = deviceId;
    }
    return deviceId;
  }

  generateRandomString(length) {
    let result = '';
    const characters = '0123456789';
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  getRandomNo(maxNo, minNo = 0) {
    return Math.max(Math.round(Math.random() * maxNo), minNo);
  }

  private openNewTab(url) {
    const browser = this.iab.create(url, '_blank', { openExternal: true });
    //browser.close();
  }

  getDCAPIEndpoint(urlKey) {
    return `${APPCONFIG.urls.nodeAPIUrl}${APPCONFIG.webActions[urlKey]}`;
  }
  
  openInNewWindow(url, checkExists = true, callback = undefined) {
    // if (url && (checkExists || Config.isOffline)) {
    //   if (Config.isOffline) {
    //     if (callback) {
    //       callback();
    //     }
    //   } else {
    //     this.httpClient.head(`${url}`).subscribe((res) => {
    //       if (callback) {
    //         callback();
    //       } else {
    //         this.openNewTab(url);
    //       }
    //     }, (err) => {
    //       console.error(err);
    //     });
    //   }
    // } else if (url && !checkExists) {
    //    this.openNewTab(url);
    // }
    this.openNewTab(url);
  }

  removeDupsFromArray(arr, key) {
    let arrObj = {};
    arr.forEach(e => {
      arrObj[e[key]] = e;
    });
    return Object.keys(arrObj).map(e => arrObj[e]);
  }

  getCurrentTimeStamp() {
    return Date.now();
  }

  getCurrentPlatform() {
    return this.platform;
  }

  isCurrentPlatformWeb() {
    return !this.getCurrentPlatform().is('cordova');
  }

  isCurrentPlatformiOS() {
    return this.platform.is('ios');
  }

  getCurrentPlatformType() {
    return this.currentPlatformType;
  }

  getInterfaceUrl(urlKey) {
    if (urlKey === 'GET_LOGO' && APPCONFIG.urls.logoBaseUrl) {
      return `${APPCONFIG.urls.logoBaseUrl}`;
    }
    return `${APPCONFIG.urls.base}${APPCONFIG.webActions[urlKey]}`;
  }

  /**
   * Get current language from session storage
   * @returns A promise
   */
  getCurrentLanguage() {
    return this.strorageService.get(StringConstants.CURRENT_Language);
  }
  /**
   * Stores current language set by user in session storage
   * @param language
   * @returns A promise
   */
  storeCurrentLanguage(language: string) {
    return this.strorageService.add(StringConstants.CURRENT_Language, language);
  }
  /**
   * Get supported multi languages from session storage
   * @returns
   */
  getSupportedLanguages() {
    return this.strorageService.get(StringConstants.SUPPORTED_Languages);
  }
  /**
   * Stores supported languages from remote server in session storage
   * @param language
   * @returns A promise
   */
  storeSupportedLanguages(languages: any[]) {
    return this.strorageService.add(StringConstants.SUPPORTED_Languages, languages);
  }
  // getUrlContent(url) {
  //   //return this.httpClient.get(url,{headers: new HttpHeaders({'Content-Type': 'text/html'})});
  //   return this.httpClient.get<any>(url, { observe: 'response', responseType: 'text'});
  // }
  translate(keys: string | string[], param?: any) {
    return this.translateService.get(keys, param);
  }
  getDeviceInfo() {
    let id = '';
    if (this.isCurrentPlatformWeb()) {
      id = `${navigator.userAgent}_${this._deviceId}_${this._imei}`;
    } else {
      id = `${this.device.manufacturer}_${this.device.model}_${this.device.platform}_${this.device.serial}_${this.device.uuid}_${this.device.version}`;
    }
    const deviceInfo = this.transformService.transformOneWay(id);
    return deviceInfo;
    //this.device.
  }

  base64toArrayBuffer(base64Str) {
    const binary_string = window.atob(base64Str);
    const len = binary_string.length;
    const bytes = new Uint8Array(len);
    for (var i = 0; i < len; i++) {
      bytes[i] = binary_string.charCodeAt(i);
    }
    return bytes.buffer;
  }

  // str - This is test data for {{buyerName}}
  // templateData - {buyerName: '123'}
  // Output This is test data for 123
  getStringWithTemplateValues(str, templateData = {}) {
    Object.keys(templateData).forEach((key) => {
      str = str.replace(new RegExp(`\\{\\{\\s*${key}\\s*\\}\\}`, 'g'), templateData[key]);
    });
    return str;
  }

  strRight(str, len) {
    return str.substring(str.length - len, str.length);
  }

  sortCollection(objArr, col, direction = 1) {
    return objArr.sort((a, b) => {
      if (a[col] < b[col]) {
        return direction === 0 ? 1 : -1;
      } else if (a[col] > b[col]) {
        return direction === 0 ? -1 : 1;
      } else {
        return 0;
      }
    });
  }


}
